import { initialArchivedCampaignsState } from "@/mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.constants";
import { ArchivedCampaignsEntity, ArchivedCampaignsSchema } from "@/mk2/apps/forum/schemas";
import { AppState } from "@/mk2/reducers";
import { getDenormalizedEntities } from "@/mk2/selectors";

export const getArchivedCampaignsState = (state: AppState) =>
    state.containers.forum.forumArchivedCampaigns || initialArchivedCampaignsState;
export const getArchivedCampaignsTopics = (state: AppState) =>
    getDenormalizedEntities<ArchivedCampaignsEntity>(
        state,
        ArchivedCampaignsSchema,
        getArchivedCampaignsState(state).ids,
    );
